<div rds-dialog-header>
  <h2 rds-dialog-title>All notifications</h2>
  <div rds-dialog-icon-placeholder>
    <button rds-icon-button size="m" [rds-dialog-close]="null">
      <rds-icon icon="close" namespace="outlined"></rds-icon>
    </button>
  </div>
</div>
<div rds-dialog-content class="dialog-content">
  @if (isLoading()) {
    <div class="loader">
      <rds-progress-spinner></rds-progress-spinner>
    </div>
  }
  @for (
    notification of latestNotifications();
    track notification.notificationId
  ) {
    <bsh-notification
      [notification]="notification"
      (isRedirectSuccessful)="closeAfterRedirect($event)"></bsh-notification>
  }
</div>
